<script lang="ts" setup>
import BaseCard from "@/components/BaseCard.vue";
import BaseContent from "./BaseContent.vue";
import BaseSubContent from "./BaseSubContent.vue";

const props = defineProps<{
    standbySkill: object;
}>();
</script>

<template>
    <BaseCard>
        <template #heading>Standby Skill</template>
        <BaseContent>
            <template #header>{{ standbySkill.name }}</template>
            {{ standbySkill.description }}

            <BaseSubContent header="condition">
                {{ standbySkill.condition }}
            </BaseSubContent>
        </BaseContent>

        <BaseContent
            v-if="standbySkill.finish_skills.length > 0"
            :header="`Finish Effect${
                standbySkill.finish_skills.length > 1 ? 's' : ''
            }`"
        >
            <ul
                :class="{
                    'ml-4 list-disc space-y-2':
                        standbySkill.finish_skills.length > 1,
                }"
            >
                <li v-for="finishSkill in standbySkill.finish_skills">
                    <div class="flex flex-col gap-1">
                        <span class="font-semibold text-green-100">{{
                            finishSkill.name
                        }}</span>
                        {{ finishSkill.description }}
                    </div>
                    <BaseSubContent class="pt-2" header="Condition">
                        {{ finishSkill.condition }}
                    </BaseSubContent>
                </li>
            </ul>
        </BaseContent>
    </BaseCard>
</template>

<style scoped></style>
